import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg overflow-hidden border border-background-200/80 hover:border-primary-300 transition-all cursor-pointer"
    >
      <div className="relative w-full sm:w-64 h-44 sm:h-auto shrink-0 overflow-hidden">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 芒果传媒动态`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4 md:p-5 flex flex-col justify-center">
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
          <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900 font-medium">
            {item.category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
        </div>
        <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-primary-700 transition-colors leading-snug">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-2 leading-relaxed line-clamp-2">
          {item.summary}
        </p>
      </div>
    </Link>
  );
}